import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useActiveUser } from '@/platform-services/auth';
import { SearchForRetailUtilities } from '@/search-for-retail/utilities';
export default function authorized(roles) {
    return (Component) => {
        const AuthorizedWrapper = (props) => {
            const navigate = useNavigate();
            const activeUser = useActiveUser();
            const notAuthorized = roles && !roles.every((role) => { var _a; return (_a = activeUser === null || activeUser === void 0 ? void 0 : activeUser.allowedAccess) === null || _a === void 0 ? void 0 : _a.includes(role); });
            useEffect(() => {
                if (notAuthorized) {
                    void navigate(SearchForRetailUtilities.navigateTo());
                }
            }, [notAuthorized, navigate]);
            if (notAuthorized) {
                return null;
            }
            return <Component {...props}/>;
        };
        AuthorizedWrapper.displayName = `authorized(${Component.displayName || Component.name || 'Component'})`;
        return AuthorizedWrapper;
    };
}
